import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Switch from "react-switch";

function WithdrawSettings({ withdrawBar, toggleWithdrawBar }) {
  const { user } = useUser();

  const [checked, setChecked] = useState();
  const [checked1, setChecked1] = useState();
  const [checked2, setChecked2] = useState();
  const [checked3, setChecked3] = useState();
  const [typeoptions, setTypeoptions] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchpayment1: true })
    })
    .then(response =>  response.json())
    .then(data => {
      const methodop = []
      if (data.status === "success") {
        data.methods.forEach(method => {
          if(method.name === "Crypto"){
            if(method.status == "1"){
              setChecked(true);
            }else{
              setChecked(false);
            }
          }
          if(method.name === "Bank Transfer"){
            if(method.status == "1"){
              setChecked1(true);
            }else{
              setChecked1(false);
            }
          }
          if(method.name === "Paypal"){
            if(method.status == "1"){
              setChecked2(true);
            }else{
              setChecked2(false);
            }
          }
          if(method.name === "Skrill"){
            if(method.status == "1"){
              setChecked3(true);
            }else{
              setChecked3(false);
            }
          }
          methodop.push({
            value: method.name,
            label: method.name,
          });
        });
        setTypeoptions(methodop);
      }
    })
    .catch(err => {
      console.error('Error fetching withdraw method!', err);
    })
  }, [user]);

  const validateWithdraw = (payment, status, setStatus) => {
    const newValue = status ? "0" : "1";
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        btn_updatewith: true, 
        payment: payment, 
        status: newValue 
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStatus(!status);
        toast.success(data.result);
      } else {
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err);
    });
  };

    return (
    <div className={`notifybar ${withdrawBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleWithdrawBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Withdrawal Settings</p>
            </div>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleWithdrawBar()}}/>
        </div>
        <div className="sidebar-navbar">
            <p className="mb-0 fw-semibold text-white">Withdrawal methods</p>
            <p className="fw-bold text-secondary" style={{fontSize: '13px'}}>Edit available withdrawal methods</p>
            {typeoptions.map((option) => {
              let ischeck, setIscheck;
              if(option.value === "Crypto"){
                ischeck = checked;
                setIscheck = setChecked;
              }else if(option.value === "Bank Transfer"){
                ischeck = checked1;
                setIscheck = setChecked1;
              }else if(option.value === "Paypal"){
                ischeck = checked2;
                setIscheck = setChecked2;
              }else if(option.value === "Skrill"){
                ischeck = checked3;
                setIscheck = setChecked3;
              }else{
                ischeck = checked;
                setIscheck = setChecked;
              }
              return (
                <div key={option.value} className="itemcard1 d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 fw-bold">{option.label}</h6>
                    <Switch
                        onChange={() => validateWithdraw(option.value, ischeck, setIscheck)}
                        checked={ischeck}
                        offColor="#404448"
                        onColor="#404448"
                        offHandleColor="#8c95a0"
                        onHandleColor="#ff6b35"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={23}
                        width={40}
                        handleDiameter={18}
                    />
                </div>
              );
            })}
        </div>
    </div>
    )
}

export default WithdrawSettings